import { api } from './client'

export interface UserHit {
  id: string
  username: string
  display_name: string
  bio?: string
  avatar_url?: string
  is_bot: boolean
}

export interface MessageHit {
  id: string
  chat_id: string
  chat_type?: string
  sender_id: string
  text: string
  created_at: string
}

export interface SearchHit {
  type: 'user' | 'channel' | 'group' | 'bot' | 'message'
  score: number
  id: string
  data: UserHit | MessageHit
}

export interface SearchResult {
  query: string
  total: number
  hits: SearchHit[]
}

export const searchApi = {
  global: (q: string, limit = 20): Promise<SearchResult> =>
    api.get(`/v1/search?q=${encodeURIComponent(q)}&limit=${limit}`),

  autocomplete: (q: string, limit = 5): Promise<{ suggestions: string[] }> =>
    api.get(`/v1/search/autocomplete?q=${encodeURIComponent(q)}&limit=${limit}`),

  // Uses messaging service directly — no Elasticsearch dependency
  inChat: (chatId: string, q: string, limit = 50): Promise<MessageHit[]> =>
    api.get(`/v1/messaging/chats/${chatId}/search?q=${encodeURIComponent(q)}&limit=${limit}`),
}
